import axios, { type AxiosInstance } from 'axios';
import { getApiUrl, initializeZafClient } from './Zendesk/zendesk';

let apiInstanceCorreios: AxiosInstance | undefined;

const correios = new Proxy<AxiosInstance>({} as AxiosInstance, {
  get(_, prop) {
    if (!apiInstanceCorreios) {
      throw new Error('API Correios ainda não inicializada.');
    }
    return (apiInstanceCorreios as AxiosInstance)[prop as keyof AxiosInstance];
  },
});

let apiInstanceColeta: AxiosInstance | undefined;
const coleta = new Proxy<AxiosInstance>({} as AxiosInstance, {
  get(_, prop) {
    if (!apiInstanceColeta) {
      throw new Error('API Correios Coleta ainda não inicializada.');
    }
    return (apiInstanceColeta as AxiosInstance)[prop as keyof AxiosInstance];
  },
});

let initialized = false;

export const initializeApi = async () => {
  if (initialized) return;

  await initializeZafClient();

  const { correiosUser, correiosPassword, correiosUrl } = await getApiUrl();

  if (!correiosUser || !correiosPassword || !correiosUrl) {
    throw new Error('Dados de configuração da API Correios estão incompletos.');
  }

  apiInstanceCorreios = axios.create({
    baseURL: correiosUrl.replace(/\/+$/, ''),
    headers: { Environment: 'production' },
  });

  apiInstanceColeta = axios.create({
    baseURL: 'https://britania-api.bcrcx.com/zendesk/correios/coleta',
    headers: { environment: 'production' },
    auth: {
      username: correiosUser,
      password: correiosPassword,
    },
  });

  apiInstanceCorreios.interceptors.request.use((config) => {
    const path = (config.url || '').toLowerCase();

    const isTokenRoute =
      path.includes('/token/v1/autentica/cartaopostagem') ||
      path.endsWith('token/v1/autentica/cartaopostagem') ||
      path.includes('token/v1/autentica') ||
      path.endsWith('token/v1/autentica');

    if (isTokenRoute) {
      // força Basic Auth
      config.auth = {
        username: correiosUser,
        password: correiosPassword,
      };

      if (config.headers) {
        delete (config.headers as any).Authorization;
      }
    } else {
      delete (config as any).auth;
    }

    return config;
  });

  initialized = true;
};

export { correios, coleta };
